<template>
  <v-container fluid class="personal-por-estatus-view ui-module-fade-in-up">
    <v-row class="toolbar-row" align="center" justify="end" no-gutters>
      <v-col cols="12" sm="4" md="3">
        <v-select
          v-model="selectedEstatus"
          :items="estatusPersonal"
          item-text="title"
          item-value="id"
          label="Estatus"
          color="secondary"
          background-color="primary"
          rounded
          filled
          dense
          hide-details
          class="filter-input"
          @change="triggerFetchPersonalPorEstatus"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4" md="3" class="ml-sm-3">
        <v-text-field
          v-model="filtroNombre"
          label="Buscar por nombre..."
          append-icon="mdi-magnify"
          color="secondary"
          background-color="primary"
          rounded
          filled
          dense
          hide-details
          clearable
          class="filter-input"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="filteredPersonal"
          :loading="loading"
          loading-text="Cargando personal..."
          no-data-text="Sin registros"
          class="ui-module-card ui-module-table tabla-personal"
          color="primary"
          :footer-props="{ 'items-per-page-text': 'Filas por página' }"
        >
          <template v-slot:[`item.nombreCompleto`]="{ item }">
            <span class="nombre-text">{{ getNombreCompleto(item) }}</span>
          </template>

          <template v-slot:[`item.CUIP`]="{ item }">
            <span class="cuip-text">{{ item.CUIP || '—' }}</span>
          </template>

          <template v-slot:[`item.puesto`]="{ item }">
            <span class="puesto-text">{{ item.puesto || '—' }}</span>
          </template>

          <template v-slot:[`item.opciones`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <IconButton
                    variant="secondary"
                    elevation="8"
                    icon="mdi-file-account"
                    :to="{
                      path: 'documentos_personal/' + item.idPersonal,
                      params: { id: item.idPersonal },
                    }"
                  />
                </span>
              </template>
              <span>Ver expediente</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import IconButton from '@/components/base/IconButton.vue'

const EDO_FZA_ID_DEPENDENCIA = 1

export default {
  components: {
    IconButton,
  },

  data() {
    return {
      loading: false,
      filtroNombre: '',
      selectedEstatus: null,
      headers: [
        { text: 'Nombre', value: 'nombreCompleto', sortable: true },
        { text: 'CUIP', value: 'CUIP', sortable: false },
        { text: 'Puesto', value: 'puesto', sortable: false },
        { text: 'Opciones', value: 'opciones', sortable: false, align: 'center' },
      ],
    }
  },

  async mounted() {
    if (this.estatusPersonal.length === 0) {
      await this.fetchEstatusPersonal()
    }

    if (this.estatusPersonal.length > 0) {
      this.selectedEstatus = this.estatusPersonal[0].id
      await this.triggerFetchPersonalPorEstatus()
    }
  },

  computed: {
    ...mapGetters('personal', {
      personalPorEstatus: 'getPersonalPorEstatus',
    }),

    ...mapGetters('estatusPersonal', {
      estatusPersonal: 'getEstatusPersonal',
    }),

    filteredPersonal() {
      return this.personalPorEstatus.filter((p) => {
        return !this.filtroNombre || this.getNombreCompleto(p).toLowerCase().includes(this.filtroNombre.toLowerCase())
      })
    },
  },

  methods: {
    ...mapActions('personal', ['fetchPersonalByDependenciaYEstatus']),
    ...mapActions('estatusPersonal', ['fetchEstatusPersonal']),

    getNombreCompleto(personal) {
      return [personal.apaterno, personal.amaterno, personal.nombre, personal.segundoNombre].filter(Boolean).join(' ')
    },

    async triggerFetchPersonalPorEstatus() {
      if (!this.selectedEstatus) return

      this.loading = true
      await this.fetchPersonalByDependenciaYEstatus({
        idDependencia: EDO_FZA_ID_DEPENDENCIA,
        estatus: this.selectedEstatus,
      })
      this.loading = false
    },
  },
}
</script>

<style scoped>
.personal-por-estatus-view {
  padding-top: 24px;
}

.toolbar-row {
  margin-bottom: 16px;
}

::v-deep .filter-input .v-input__slot {
  background: rgba(8, 14, 19, 0.52) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 14px !important;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2) !important;
}

::v-deep .filter-input .v-label,
::v-deep .filter-input input,
::v-deep .filter-input .v-icon,
::v-deep .filter-input .v-select__selection {
  color: #e0f0ff !important;
}

::v-deep .filter-input.v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.16) !important;
}

::v-deep .filter-input .v-input__slot {
  min-height: 40px !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative !important;
  overflow: hidden !important;
}

::v-deep .v-btn:hover:not(:disabled):not(.v-btn--text) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

::v-deep .v-btn.secondary--text {
  border-color: var(--v-secondary-base) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease !important;
  color: inherit !important;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.1) !important;
}
</style>
